import { Injectable, inject } from '@angular/core';
import {
  ICumplimientoRecorrido,
  ICumplimientoRecorridoVivo,
  IListado,
  IQueryParam,
} from 'modelos/src';
import { HttpClientService } from '../http.service';
import { HelperService } from '../helper.service';

/**
 * Cumplimiento de recorridos de vehículos (real vs deseado).
 *
 * El estado en vivo NO es una entidad de Mongo: lo mantiene api-eventos en Redis
 * por cada reporte y api-gestion lo sirve como snapshot. Por eso no pasa por
 * `Lista2Service` (no hay websocket de entidad al que suscribirse): se consulta
 * al abrir el panel y cada vez que llega un reporte nuevo del vehículo.
 */
@Injectable({
  providedIn: 'root',
})
export class CumplimientosRecorridoService {
  private http = inject(HttpClientService);

  /** Snapshot de la medición en curso. `null` si el vehículo no está midiendo. */
  public getVivo(idActivo: string): Promise<ICumplimientoRecorridoVivo | null> {
    return this.http.get(`/cumplimientos-recorrido/vivo/${idActivo}`);
  }

  /** Descarta la medición en curso; el próximo reporte on-route arranca otra. */
  public reiniciarVivo(idActivo: string): Promise<void> {
    return this.http.delete(`/cumplimientos-recorrido/vivo/${idActivo}`);
  }

  public getFiltered(
    queryParams?: IQueryParam,
  ): Promise<IListado<ICumplimientoRecorrido>> {
    const params = HelperService.getQueryParams(queryParams);
    return this.http.get(`/cumplimientos-recorrido`, { params });
  }

  public getById(id: string): Promise<ICumplimientoRecorrido> {
    return this.http.get(`/cumplimientos-recorrido/${id}`);
  }
}
